import { getSanityImgUrl } from "@lib/sanity";
import { styled } from "@sourceful/shared-components";
import { SanityLogoWallSection, ImageLink, ImageWithCaption } from "@sourceful/shared-types";
import StandardLink from "@components/siteHeader/StandardLink";
import BasePageSection from "../BasePageSection";

const LogoWallCardsWrapper = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
});

const LogoWallCard = styled("div", {
  marginLeft: "10px",
  marginRight: "10px",
});

const StyledImage = styled("img", {
  width: 150,
  height: 150,
  "@md": {
    width: 200,
    height: 200,
  },
  "@lg": {
    width: 250,
    height: 250,
  },
});

interface LogoWallSectionProps {
  section: SanityLogoWallSection;
}

export const LogoWallSection = ({ section }: LogoWallSectionProps) => {
  return (
    <BasePageSection section={section} minHeight="200px">
      {!!section.logos && (
        <LogoWallCardsWrapper>
          {section.logos?.map(logo => {
            const logoImage = logo._type === "imageWithCaption" ? logo : (logo as ImageLink).image;

            const logoElement = (
              <StyledImage
                src={getSanityImgUrl((logoImage as ImageWithCaption).asset._ref || "", base =>
                  base.height(400)
                )}
                alt={(logoImage as ImageWithCaption)?.metadata?.caption}
                loading="lazy"
              />
            );

            if ((logo as ImageLink)?.link) {
              return (
                <StandardLink
                  internalLink={(logo as ImageLink)?.link.internalLink}
                  externalLink={(logo as ImageLink)?.link.externalLink}
                >
                  {logoElement}
                </StandardLink>
              );
            }
            return (
              <LogoWallCard key={(logoImage as ImageWithCaption).asset._ref}>
                {logoElement}
              </LogoWallCard>
            );
          })}
        </LogoWallCardsWrapper>
      )}
    </BasePageSection>
  );
};

export default LogoWallSection;
